import { render, staticRenderFns } from "./BitacoraPantalla.vue?vue&type=template&id=6696c470&"
import script from "./BitacoraPantalla.vue?vue&type=script&lang=ts&"
export * from "./BitacoraPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6696c470', component.options)
    } else {
      api.reload('6696c470', component.options)
    }
    module.hot.accept("./BitacoraPantalla.vue?vue&type=template&id=6696c470&", function () {
      api.rerender('6696c470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Bitacora/BitacoraPantalla.vue"
export default component.exports